<!--
 * @Author: vince
 * @Date: 2021-08-19 14:32:46
 * @LastEditors: vince 273187189@qq.com
 * @LastEditTime: 2023-03-13 18:53:35
 * @Description:
-->
<template>
  <div class="uploda-mc">
    <el-upload
      auto-upload
      class="uploader"
      :action="action"
      :on-preview="handlePreview"
      :multiple="multiple"
      :on-remove="handleRemove"
      :on-progress="handleProgress"
      :before-remove="beforeRemove"
      :on-success="onSuccess"
      :on-error="onError"
      :limit="limit"
      :on-exceed="handleExceed"
      :file-list="fileList"
      :accept="accept"
      :list-type="listType"
      :disabled="disabled"
      :data="qnData"
      :headers="headers"
      :before-upload="beforeUpload"
    >
      <!-- <i class="el-icon-upload"></i>
  		<div class="el-upload__text">
  			将文件拖到此处，或
  			<em>点击上传</em>
  			</div>-->
      <el-button
        v-if="listType == 'text'"
        size="small"
        icon="el-icon-upload"
        type="primary"
        >点击上传</el-button
      >
      <i class="el-icon-plus" v-if="listType == 'picture-card'"></i>
      <div v-if="listType == 'text'" slot="file" slot-scope="{ file }">
        <i class="item-document el-icon-document"></i>
        {{ file.attachName + "---" }} {{ file.attachSize }}kb
        <i @click="handleRemove(file)" class="item-delete el-icon-delete"></i>
        <el-progress
          v-if="file.status != 'success'"
          class="up-progress"
          size="mini"
          :percentage="percent"
        ></el-progress>
      </div>
      <div slot="tip" class="el-upload__tip">
        <!-- <slot>{{ tipDesc }}</slot> -->
        (单个文件不超过{{ maxSize | fileSizeFilter }})
      </div>
    </el-upload>
    <!-- <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
        <img width="100%" :src="dialogImageUrl" alt />
      </el-dialog> -->
  </div>
</template>

<script>
import { conf } from "@/config";
import { getData } from "@/http/fetch.js";
import Compressor from "compressorjs";
export default {
  props: {
    // action: {
    // 	type: String,
    // 	default: () => {
    // 		return "/dpt-web/file/uploadFile";
    // 	}
    // },
    maxSize: {
      //单位kb
      type: Number,
      default: 200 * 1024,
    },
    headers: {
      type: Object,
    },
    data: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: 10,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    fileList: {
      type: Array,
    },
    accept: {
      type: String,
      default: "image/*",
    },
    listType: {
      //text/picture/picture-card
      type: String,
      default: "text",
    },
  },
  computed: {
    action() {
      return conf.uploadAction;
    },
  },
  data() {
    return {
      percent: 0,
      qnData: {
        token: "",
        key: "",
      },
      domainUrl: "",
    };
  },
  filters: {
    fileSizeFilter(value) {
      if (null == value || value == "") {
        return "0 Bytes";
      }
      var unitArr = new Array(
        "Bytes",
        "KB",
        "MB",
        "GB",
        "TB",
        "PB",
        "EB",
        "ZB",
        "YB"
      );
      var index = 0;
      var srcsize = parseFloat(value);
      index = Math.floor(Math.log(srcsize) / Math.log(1024));
      var size = srcsize / Math.pow(1024, index);
      size = size.toFixed(2); //保留的小数位数
      return size + unitArr[index];
    },
  },
  methods: {
    getToken(file) {
      return getData("/file/getQiNiuAccessToken")
        .then((res) => {
          this.domainUrl = res.domainUrl;
          this.qnData.token = res.accessToken;
          this.qnData.key =
            new Date().getTime() +
            "." +
            file.name.split(".")[file.name.split(".").length - 1]; // 处理上传同名文件失败加上时间戳
        })
        .catch((err) => {
          this.$message({ type: "error", message: err });
        });
    },
    presser(file) {
      return new Promise((resolve, reject) => {
        new Compressor(file, {
          maxWidth: 2000,
          maxHeight: 2000,
          quality: 0.8,
          success: (result) => {
            return resolve(result);
          },
          error: (err) => {
            reject(err);
            this.$message({ type: "error", message: err });
          },
        });
      });
    },
    async beforeUpload(file) {
      console.log(file.size, 'file.size');
      console.log(this.maxSize, 'this.maxSize');
      console.log(this.maxSize * 1024, 'this.maxSize * 1024');
      if (file.size > this.maxSize) {
        this.$message.error(`文件 ${file.name}大小超出限制，已忽略该文件。`);
        return false;
      }
      if (file.type.includes("video")) {
        this.getDuration(file).then((res) => {
          file.duration = res;
        });
      }
      await this.getToken(file);
      if (file.type.includes("image")) {
        return this.presser(file);
      } else {
        return true;
      }
    },
    handleRemove(file, fileList) {
      let attachName = file.attachName;
      let index = this.fileList.findIndex((f) => f.attachName == attachName);
      if (index > -1) {
        this.fileList.splice(index, 1);
        this.$emit("update:fileList", this.fileList);
      }

      this.$emit("onRemove", { file, fileList });
    },
    handlePreview(file) {
      this.$emit("onPreview", file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 ${this.limit} 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file, fileList) {
      //return this.$confirm(`确定移除 ${file.name}？`);
    },
    onSuccess(response, file, fileList) {
      console.log("response", response);
      console.log("fileList", fileList);
      if (response) {
        let list = fileList.map((m) => {
          if (m.response) {
            if (m.raw.type.includes("video")) {
              return {
                uid: m.uid,
                name: this.domainUrl + m.response.key,
                url: this.domainUrl + m.response.key,
                attachName: m.name,
                attachSize: parseFloat(m.size / 1024).toFixed(0),
                attachType: m.name.replace(/.+\./, "").toLowerCase(),
                attachUrl: this.domainUrl + m.response.key,
                ...m.response.data,
                duration: m.raw.duration,
              };
            } else {
              return {
                uid: m.uid,
                name: this.domainUrl + m.response.key,
                url: this.domainUrl + m.response.key,
                attachName: m.name,
                attachSize: parseFloat(m.size / 1024).toFixed(0),
                attachType: m.name.replace(/.+\./, "").toLowerCase(),
                attachUrl: this.domainUrl + m.response.key,
                ...m.response.data,
              };
            }
          } else {
            return m;
          }
        });
        this.$emit("update:fileList", list);
        this.$emit("uploaded", { response, file, fileList: list });
      } else {
        console.log(response, file, fileList);
        this.$message.error(`文件${file.name}上传失败,${response.msg}`);
      }
    },
    onError(err, file, fileList) {
      this.$message.error(`文件${file.name}上传失败，请稍后再试！`);
    },
    handleProgress(event, file, fileList) {
      this.percent = parseInt(event.percent + 0);
    },
    getDuration(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          const video = document.createElement("video");
          video.preload = "metadata";
          video.onloadedmetadata = () => {
            window.URL.revokeObjectURL(video.src);
            resolve(video.duration);
          };
          video.onerror = () => reject(new Error("Video loading error"));
          video.src = event.target.result;
        };
        reader.onerror = () => reject(new Error("File reading error"));
        reader.readAsDataURL(file);
      });
    },
  },
};
</script>
<style lang="less" scoped>
.uploda-mc {
  // border:1px solid red;
  .item-delete {
    width: 20px;
    height: 20px;
    cursor: pointer;
    margin-left: 20px;
  }
}

.item-document {
  margin-left: 10px;
}

.item-delete:hover {
  color: red;
}

::v-deep.up-progress {
  .el-progress-bar__outer {
    height: 3px !important;
  }
}
</style>
